import React from "react";

// Colored store logos — same SVGs as prod getStoreIcon (src/helpers).
export { ReactComponent as AppStoreIcon } from "./assets/AppStoreLogo.svg";
export { ReactComponent as GoogleStoreIcon } from "./assets/GoogleStoreLogo.svg";

/**
 * Bookmark favorite — exact Figma "20 / Favorite-icon" glyph. Always the
 * filled shape; the state is conveyed by currentColor (quaternary gray by
 * default, brand when saved).
 */
export const BookmarkIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M4.00001 6.5C4.00001 5.09987 4.00001 4.3998 4.28028 3.86502C4.52681 3.39462 4.92019 3.01217 5.40403 2.77248C5.95409 2.5 6.67416 2.5 8.1143 2.5H11.8857C13.3259 2.5 14.0459 2.5 14.596 2.77248C15.0798 3.01217 15.4732 3.39462 15.7197 3.86502C16 4.3998 16 5.09987 16 6.5V13.4212C16 14.7631 16 15.434 15.7179 15.8264C15.4717 16.1687 15.0928 16.3917 14.674 16.4406C14.194 16.4967 13.6075 16.1708 12.4345 15.5191L10 14.1667L7.56555 15.5191C6.39253 16.1708 5.80601 16.4967 5.326 16.4406C4.90718 16.3917 4.52829 16.1687 4.28214 15.8264C4.00001 15.434 4.00001 14.7631 4.00001 13.4212V6.5Z" />
  </svg>
);

/** 10 / arrow-narrow-right-icon between the start and end dates. */
export const ArrowNarrowRightIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 10 10"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M1.2 5h7.6" />
    <path d="M6 2.2 8.8 5 6 7.8" />
  </svg>
);

/** 16 / Arrow-left-icon rotated 180° — the "›" chevron in the round row-open button. */
export const OpenArrowIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M6.6875 3.625 11.0625 8l-4.375 4.375" />
  </svg>
);
